import React from "react";

function DeliverBestCryBot() {
  return (
    <>
      <div className="about-style-five-area default-padding">
        <div className="container">
          <div className="row">
            <div className="col-xl-6 col-lg-5">
              <div className="about-style-five-left-info ">
                <h2>We Deliver Best Crypto Bot Development Service</h2>
                <p>
                  By leveraging sophisticated algorithms, real-time data
                  processing, and customizable features, our bots adapt to any
                  trading style or market condition.
                </p>
                <ul className="list-style-two">
                  <li>Margin Trading Bots</li>
                  <li>Arbitrage Bots</li>
                  <li>Sniper Bots</li>
                  <li>Copy Trading Bots</li>
                  <li>MEV Bots</li>
                  <li>Flashloan Bots</li>
                  <li>AI-trading Bots</li>
                  <li>Inter-exchange Trading Bots</li>
                  <li>Farming Bots</li>
                  <li>Signal Trading Bots</li>
                </ul>
                <a className="btn btn-style-one mt-30" href="#">
                  Explore More
                </a>
              </div>
            </div>
            <div className="col-xl-5 offset-xl-1 col-lg-7">
              <div className="about-style-five-right-info">
                <h2 className="title split-text-right split-text-in-right split-lines">
                  Advance solutions by creative power
                </h2>
                <ul className="feature-list">
                  <li>
                    <div className="icon">
                      <img
                        src="https://validthemes.net/site-template/robok/assets/img/icon/5.png"
                        alt="Image Not Found"
                      />
                    </div>
                    <div className="info">
                      <h4>Social Media Advancements</h4>
                      <p>
                        AI is advancing fields that offer exciting chance for
                        modern innovation.
                      </p>
                    </div>
                  </li>
                  <li>
                    <div className="icon">
                      <img
                        src="https://validthemes.net/site-template/robok/assets/img/icon/6.png"
                        alt="Image Not Found"
                      />
                    </div>
                    <div className="info">
                      <h4>Entrepreneur Opportune</h4>
                      <p>
                        AI is advancing fields that offer exciting chance for
                        modern innovation.
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DeliverBestCryBot;
